import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {FormFieldValidationSchema} from './formFieldValidation'

export const FormFieldSelectSchema = buildEntrySchemaFor('formFieldSelect', {
  fields: z.lazy(() =>
    z.object({
      htmlName: z.string(),
      label: z.string(),
      options: z.looseObject({}).catchall(z.string()),
      validations: z.array(FormFieldValidationSchema).optional(),
    }),
  ),
})

export type FormFieldSelect = z.infer<typeof FormFieldSelectSchema>

export const isFormFieldSelect = (value: unknown): value is FormFieldSelect => {
  return FormFieldSelectSchema.safeParse(value).success
}
